import { checkWin, getUrlQuery, queryToObj } from ".";
export var getBizModuleInfo = function() {
    var configModuleInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var result = {};
    if (checkWin()) {
        var query = getUrlQuery();
        var arms_biz_product_id = queryToObj(query).arms_biz_product_id;
        if (arms_biz_product_id) {
            result.product_id = decodeURIComponent(arms_biz_product_id);
        }
    }
    if (Object.keys(result).length === 0) {
        var _configModuleInfo, _configModuleInfo1;
        if ((_configModuleInfo = configModuleInfo) === null || _configModuleInfo === void 0 ? void 0 : _configModuleInfo.moduleId) {
            result.module_id = configModuleInfo.moduleId;
        }
        if ((_configModuleInfo1 = configModuleInfo) === null || _configModuleInfo1 === void 0 ? void 0 : _configModuleInfo1.productId) {
            result.product_id = configModuleInfo.productId;
        }
    }
    return result;
};

 //# sourceMappingURL=biz-module-info.js.map